import { defineComponent as _defineComponent } from 'vue';
import { transitionDuration } from "@common/utils/DOM";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    active: {
      type: Boolean
    },
    slideInOut: {
      type: Boolean,
      default: true
    },
    color: {
      default: 'secondary'
    },
    percentage: null,
    size: {
      default: 'default'
    },
    position: {
      default: 'bottom'
    }
  },
  setup(__props) {
    const props = __props;
    const rootEl = ref();
    const visible = ref(false);
    const isDeterminate = computed(() => {
      return props.percentage != undefined;
    });
    watch(() => props.active, val => {
      if (val) {
        visible.value = true;
        return;
      }
      if (!rootEl.value) return;
      const parentEl = rootEl.value.parentElement;
      if (!parentEl) return;
      let width = rootEl.value.offsetWidth;
      let parentWidth = parentEl.offsetWidth;
      let remainingDuration = transitionDuration(rootEl.value) * (1 - width / parentWidth);
      if (!isNaN(remainingDuration)) {
        setTimeout(function () {
          visible.value = props.active;
        }, remainingDuration + 50);
      } else visible.value = val;
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      props,
      rootEl,
      visible,
      isDeterminate
    };
  }
});